<!-- <h1 mat-dialog-title>Hi </h1> -->
<div mat-dialog-content style="width: 320px;">

  <div   >
    <h4>Tracking Number</h4>
    <br>
    <p>
      <strong>Tracking link: </strong> <a target="_blank" [href]="TrackingUrl">link</a><br>
      <strong>TrackingNumber: </strong> {{TrackingNumber}}
    </p>
  </div>
</div>
